import axios from 'axios'
const checklistApi = axios.create({
  baseURL: process.env.VUE_APP_CHECKLIST_URL,
  headers: {
    common: {
      'X-AccessToken': process.env.VUE_APP_CHECKLIST_ACCESS_TOKEN,
      'x-auth-token': process.env.VUE_APP_CHECKLIST_AUTH_TOKEN
    }
  }
})

// eslint-disable-next-line
const document_url = 'https://checklistapi.apphouse.no/'
// eslint-disable-next-line
export { checklistApi, document_url }
